import { cn } from '../utils/cn';

interface ProgressBarProps {
  value: number;
  max?: number;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  label?: string;
  className?: string;
}

const sizeMap = { sm: 'h-1.5', md: 'h-2.5', lg: 'h-4' };

export default function ProgressBar({ value, max = 100, color, size = 'md', showLabel, label, className }: ProgressBarProps) {
  const percent = Math.min((value / max) * 100, 100);

  return (
    <div className={cn('w-full', className)}>
      {(showLabel || label) && (
        <div className="flex items-center justify-between mb-1">
          {label && <span className="text-xs text-content-secondary">{label}</span>}
          {showLabel && <span className="text-xs font-medium text-content-primary">{Math.round(percent)}%</span>}
        </div>
      )}
      <div className={cn('w-full rounded-full bg-surface-card-hover overflow-hidden', sizeMap[size])}>
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${percent}%`, backgroundColor: color || 'var(--color-primary)' }}
        />
      </div>
    </div>
  );
}
